var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGostock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1141,
    cy: 12.3107,
    rx: 11.2258,
    ry: 11.2109,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8022 11.7756V18.6086L17.8552 16.2879V9.4557L12.8022 11.7756Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11682 8.50904L11.8552 10.7177L16.5922 8.50904L11.8552 6.29919L7.11682 8.50904Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16943 16.2879L11.2224 18.6085V11.7756L6.16943 9.4557V16.2879Z",
    fill: "#FF9900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.751495C5.37257 0.751495 0 6.12414 0 12.7515C0 19.3789 5.37257 24.7515 12 24.7515C18.6274 24.7515 24 19.3789 24 12.7515C24 6.12413 18.6274 0.751495 12 0.751495ZM19.1106 17.3158L12.0243 20.5187L4.88932 17.2837V8.28335L11.8546 4.98425L19.1106 8.28335V17.3158Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGostock);
export default __webpack_public_path__ + "static/media/gostock.b117871a.svg";
export { ForwardRef as ReactComponent };